import React, {useEffect, useState} from 'react';
import {Box, Button, Dialog, DialogActions, DialogContent, DialogTitle} from "@mui/material";
import OrderService from "../../../../../API/orders/orders/organization/OrderService";
import OrderUtil from "../../../../../utils/orders/OrderUtil";
import OrderTable from "../../orders/organization/order/OrderTable";
import ButtonExit from "../../../button/ButtonExit";
import ButtonAdd from "../../../button/ButtonAdd";
import {calcFilterData} from "../../../../../utils/common/calcFilterData";
import {OrderTableFilterData} from "../../../../../data/FilterTables/OrderTableFilterData";
import {orderStatus} from "../../../../../data/OrderStatus";
import DataUtil from "../../../../../utils/common/DataUtil";

const ModalDeleteOrdersInIssuingEdge = ({
                                            open,
                                            onClose,
                                            deleteOrdersInIssuingEdge,
                                            issuingEdgesId,
                                            titleModal,
                                            handleModalAlert
                                        }) => {
    const [rowSelection, setRowSelection] = useState([]);
    const [data, setData] = useState([]);
    const [customerList, setCustomerList] = useState([]);
    const [nameList, setNameList] = useState([]);
    const [planningList, setPlanningList] = useState([]);
    const [statusList, setStatusList] = useState([]);
    const [filteredData, setFilteredData] = useState(data)
    const [globalFilter, setGlobalFilter] = useState('');
    const [columnsFilter, setColumnsFilter] = useState([]);
    const [tableOptions, setTableOptions] = useState({
        pageIndex: 0,
        pageSize: 10,
        totalElements: 0,
        searchData: ""
    })
    const tableOptionsHandle = (nextState) => {
        setTableOptions(nextState)
    }
    const handleSearchQuery = (searchQuery, prevData, pageSize, isColumnFilters) => {
        const newColumnsFilter = isColumnFilters ? searchQuery : columnsFilter
        const newGlobalFilter = isColumnFilters ? globalFilter : searchQuery || ""

        const data = [...prevData]
        const globalFilterData = newGlobalFilter ? calcFilterData(data, newGlobalFilter, OrderTableFilterData) : data
        const newData = newColumnsFilter.reduce((accumulator, currentValue) => {
            return calcFilterData(accumulator, currentValue?.value, [OrderTableFilterData.find(el => el.idFromColumnFilter === currentValue.id)])
        }, globalFilterData);

        setFilteredData(newData)

        tableOptionsHandle({
            ...tableOptions,
            totalElements: newData.length,
            pageSize: pageSize ? pageSize : tableOptions?.pageSize
        })

        if (isColumnFilters) {
            setColumnsFilter(searchQuery)
        } else {
            setGlobalFilter(searchQuery || "")
        }
    }

    const setLists = (data) => {
        setCustomerList(OrderUtil.getListField(data, 'customerName'));
        setNameList(DataUtil.getListChildField(data, 'header', 'name'));
        setPlanningList(DataUtil.getListChildField(data, 'plan', 'name'));
        setStatusList(OrderUtil.getListFieldByEnum(data, 'status', orderStatus));
    }
    useEffect(() => {
        if (issuingEdgesId) {
            OrderService.getAllByIssuingEdgesId(issuingEdgesId).then(function (response) {
                const data = response.data?.sort((a, b) => b.id - a.id)
                setData(data);
                handleSearchQuery("", data, data.length)
                setLists(data)
            })
                .catch(function (error) {
                    handleModalAlert(error);
                });
        }

    }, [issuingEdgesId]);

    return (
        <div>
            <Dialog open={open} fullWidth={true} PaperProps={{
                style: {
                    minWidth: "1400px"
                }
            }}>
                <DialogTitle textAlign="center">{titleModal}</DialogTitle>
                <DialogContent>
                    <Box sx={{mt: '0.2rem'}}>
                        <Box sx={{mt: '0.2rem'}}>
                            <OrderTable
                                data={data}
                                setData={setData}
                                customerList={customerList}
                                nameList={nameList}
                                planningList={planningList}
                                enableEditing={false}
                                isIssuingEdge={true}
                                tableOptions={tableOptions}
                                tableOptionsHandle={tableOptionsHandle}
                                handleModalAlert={handleModalAlert}
                                rowSelection={rowSelection}
                                setRowSelection={setRowSelection}
                                globalFilter={globalFilter}
                                filteredData={filteredData}
                                handleSearchQuery={handleSearchQuery}
                                columnsFilter={columnsFilter}
                                setLists={setLists}
                                statusList={statusList}
                            />
                        </Box>
                    </Box>
                </DialogContent>
                <DialogActions sx={{p: '1.25rem'}}>
                    <ButtonExit text={"Выйти"} onClick={onClose}/>
                    <ButtonAdd text={"Удалить"} disabled={rowSelection.length === 0}
                               onClick={() => deleteOrdersInIssuingEdge(rowSelection)}/>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default ModalDeleteOrdersInIssuingEdge;